import React, { useState } from 'react'
import { Trans, t } from '@lingui/macro'

import Button from '@material-ui/core/Button'
import cookie from 'js-cookie'
import { useSnackbar } from 'notistack'
import { withI18n } from '@lingui/react'

function CookieConsent({ i18n }) {
  const [shouldShowCookieConsent, setCookieConsentVisibility] = useState(
    !cookie.get('kd-cookie_consent')
  )

  if (shouldShowCookieConsent) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()

    enqueueSnackbar(
      i18n._(
        t`Rádi bychom používali Google Analytics a Facebook pixel. Tyto služby nám pomáhají vylepšovat náš web. Zvažte prosím přijetí.`
      ),
      {
        action: (
          <Button
            color="primary"
            onClick={() => {
              cookie.set('kd-cookie_consent', true, { expires: 365 })
              closeSnackbar()
            }}
          >
            <Trans>Přijmout</Trans>
          </Button>
        ),
        anchorOrigin: {
          horizontal: 'right',
          vertical: 'bottom',
        },
        onEntered() {
          setCookieConsentVisibility(false)
        },
        persist: true,
        variant: 'cookie',
      }
    )
  }

  return false
}

export default withI18n()(CookieConsent)
